<template>
    <v-dialog
        :value="dialog"
        @input="$emit('close-modal', $event)">
		<div>
			<v-card class="new-survey1 open-modal">
				<v-card-title class="title" :style="`color:${$appColors.secondary}`">
					{{ title }}
				</v-card-title>
				<v-card-text tw-py-2>
					<slot></slot>
				</v-card-text>
				<v-card-actions class="background-footer-modal"
					:style="`border-top:1px solid ${$appColors.gray};`"
					v-if="footer">
						<v-layout wrap justify-center>
							<v-flex xs2 mx-4 v-if="$route.name === 'process-choose-evaluators'">
								<v-btn
									:color="`${$appColors.gray};`"
									type="button"
									class="btn btn-action"
									@click="$emit('close-modal', $event)"
								>
									Cancelar
								</v-btn>
							</v-flex>
							<v-flex xs2 mx-4>
								<v-btn
									:color="color"
									type="button"
									class="btn btn-action btn-disabled-background"
									@click="$emit('create-employee')"
								>
									{{ title }}
								</v-btn>
							</v-flex>
						</v-layout>
				</v-card-actions>
			</v-card>
		</div>
    </v-dialog>
</template>

<script>
export default {
	name: 'modal-action',
	props: {
		dialog: {
			type: Boolean,
			default: false,
		},
		create: {
			type: Boolean,
			default: true,
		},
		footer: {
			default: true,
			type: Boolean,
		},
		title: {
			type: String,
			default: '',
		},
		color: {
			type: String,
			default: 'primary',
		},
	},
};
</script>

<style lang="scss" scoped>
.new-survey1 {
	position: fixed !important;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	padding: 0px;

	&-input {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, gray-slider);
		border-radius: 4px;
		color: map-get($colors, secondary);
		display: block;
		margin-top: 4px;
		outline: none;
		padding: 6px 20px;
		width: 100%;

		&::placeholder {
			color: map-get($colors, placeholder);
		}
	}

	&-label {
		color: map-get($colors, secondary);
		font-size: 11px;
		margin-bottom: 10px;
	}

	&.theme--light.v-sheet {
		background: map-get($colors, gray-light);
	}
}

.title {
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	text-align: start;
}

.open-modal{
	background-color: map-get($colors, gray-light);
	box-shadow: 0 2px 21px 0 rgba(68, 68, 68, 0.5);
	width: 30%;
	height: auto;
	border-radius: 20px;
	@media (max-width: 768px){
		width: 100%;
		height: 40%;
		zoom:100%;
	}
}
.background-footer-modal {
	background-color: map-get($colors, white);
	bottom: 0;
	left: 0;
	padding: 10px 0;
	gap: 10px;
	position: relative;
	width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/evaluations/modal-action.vue